import { ChangeDetectorRef, Component, EventEmitter, NgZone, OnDestroy, OnInit, Output } from '@angular/core';
import { MessagingService } from '../../../services/messaging.service';
import {Globals} from '../../../globals';
import {MessagingConstants} from '../../../models/MessagingConstants';
import {PatientCaseWorkItemFormDataModel} from '../../../models/forms/data/patient-case-work-item-form-data.model';
import {DataPatientCaseWorkItemModel} from '../../../models/accountsReceivable/data-patient-case-work-item.model';

@Component({
  standalone: false,
  selector: 'app-case-form-view',
  templateUrl: './case-form-view.component.html',
  styleUrls: ['./case-form-view.component.css']
})
export class CaseFormViewComponent implements OnInit, OnDestroy {

  @Output() onFormCompleted: EventEmitter<any> = new EventEmitter();

  currentEnumCustomFormID: string;
  currentCaseWorkItemFormsId: string;
  currentCaseId: string;
  messageSubscription: any;
  private formEditStartTimeoutId?: ReturnType<typeof setTimeout>;
  private caseChangedTimeoutId?: ReturnType<typeof setTimeout>;
  private isDestroyed = false;
  currentCaseWorkItemForm: PatientCaseWorkItemFormDataModel;
  currentCaseWorkItem: DataPatientCaseWorkItemModel;
  currentTreatmentPlanId:string;
  currentToothId: string;

  //
  isDemoWorkstation: boolean = false;

  // Forms
  /////////////////////////////////////////////////////////////////////
  customFormPerio             = '00000039-1000-0000-0000-000000000001';
  customFormTreatment         = '00000039-1000-0000-0000-000000000003';
  customFormFinalReport       = '00000039-1000-0000-0000-000000000006';
  customFormTreatmentPlanning = '00000039-1000-0000-0000-000000000007';
  customFormRecall            = '00000039-1000-0000-0000-000000000008';
  customFormMti               = '00000039-1000-0000-0000-000000000009';
  customFormDiagnosis         = '00000039-1000-0000-0000-000000000010';
  customFormTreatmentPlanApproval = '00000039-1000-0000-0000-000000000011';
  customFormSurgicalDiagnosis   = '00000039-1000-0000-0000-000000000012';
  customFormSurgicalTreatment   = '00000039-1000-0000-0000-000000000013';

  constructor(private readonly messagingService: MessagingService,
              public globals: Globals,
              private readonly cdr: ChangeDetectorRef,
              private readonly ngZone: NgZone) { }

  ngOnDestroy(): void {
    this.isDestroyed = true;
    if (this.messageSubscription)
      this.messageSubscription.unsubscribe();
    clearTimeout(this.formEditStartTimeoutId);
    clearTimeout(this.caseChangedTimeoutId);
  }
  formCompleted(event: any) {
    console.log("CaseFormViewComponent onFormCompleted: ", event);
    this.onFormCompleted.emit(event);
  }

  ngOnInit() {

    let hostName: string = globalThis.location.hostname;
     console.log('CaseFormViewComponent ngOnInit hostName: ', hostName);
    if (hostName.includes('localhost') || hostName.includes('tdosdemo'))
      this.isDemoWorkstation = true;
    this.messageSubscription = this.messagingService.componentMessageCall.subscribe(response => {
      if (response.event === MessagingConstants.FORM_EDIT_START) {
        this.currentCaseId = this.globals.currentPatientCaseId;
        
        if (response.data) {
          // Defer the reset to a macrotask so it runs after the current CD pass completes,
          // preventing NG0100 when the subscription fires synchronously during CD.

          this.formEditStartTimeoutId = setTimeout(() => {
            this.ngZone.run(() => {
              this.currentTreatmentPlanId = undefined;
              this.currentCaseWorkItemFormsId = undefined;
              this.currentEnumCustomFormID = undefined;
              this.currentCaseWorkItemForm = undefined;
              this.currentCaseWorkItem = undefined;
              this.currentToothId = undefined;
              this.currentCaseWorkItem = response.data.caseWorkItem;
              this.currentCaseWorkItemFormsId = response.data.CaseWorkItemFormsId;
              if (this.currentCaseWorkItemFormsId) {
                this.globals.currentPatientCaseWorkItemFormsID = this.currentCaseWorkItemFormsId;
              }

              this.currentTreatmentPlanId = response.data.TreatmentPlanId;
              if (this.currentTreatmentPlanId) {
                this.globals.currentTreatmentPlanID = this.currentTreatmentPlanId;
              }
              this.currentEnumCustomFormID = response.data.enumCustomFormId;
              this.currentCaseWorkItemForm = response.data.form;
              this.currentToothId = this.currentCaseWorkItem?.dataPatientCaseItemTeeth[0]?.ToothID;
              if (!this.isDestroyed) {
                this.cdr.detectChanges();
              }
            });
          }, 100);
        }
      }
      else if (response.event === MessagingConstants.CASE_CHANGED_EVENT) {
        // Defer mutations to a macrotask so they run after the current CD pass completes,
        // preventing NG0100 when the subscription fires synchronously during CD.
        this.caseChangedTimeoutId = setTimeout(() => {
          this.ngZone.run(() => {
            this.currentCaseWorkItemFormsId = null;
            this.globals.currentPatientCaseWorkItemFormsID = null;
            if(localStorage.getItem('isSelectedMTI') !== 'true') {
              this.currentEnumCustomFormID = null;
            }
            const viewRef = this.cdr as any;
            if (!viewRef.destroyed) {
              this.cdr.detectChanges();
            }
          });
        });
      }
    });
  }
}
